export const COMPARE_PAGE_ADD_PRODUCT = 'COMPARE_PAGE_ADD_PRODUCT';
export const COMPARE_PAGE_CLEARALL = 'COMPARE_PAGE_CLEARALL';
export const COMPARE_PAGE_REMOVE_PRODUCT = 'COMPARE_PAGE_REMOVE_PRODUCT';
export const DYNAMIC_VISNAV_CLICK = 'DYNAMICVISNAV_CLICK';
export const GALLERY_VIDEO_PLAYER_ANALYTICS = 'GALLERY_VIDEO_PLAYER_ANALYTICS';
export const GET_GALLERY_DETAILS_BY_ID_ERROR = 'GET_GALLERY_DETAILS_BY_ID_ERROR';
export const NAVIGATION_DATA_CLICK = 'NAVIGATION_DATA_CLICK';
export const ON_COMPARE_PAGE_READY = 'ON_COMPARE_PAGE_READY';
export const ON_PAGE_READY = 'ON_PAGE_READY';
export const PRODUCT_FILTERS_APPLIED = 'PRODUCT_FILTERS_APPLIED';
export const PROMOTED_FILTERS_APPLIED = 'PROMOTED_FILTERS_APPLIED';
export const PROMOTED_FILTERS_RESET = 'PROMOTED_FILTERS_RESET';
export const SB_PAGE_CHANGE = 'SB_PAGE_CHANGE';
export const SEARCH_RESULT_CLICK = 'SEARCH_RESULT_CLICK';
export const TRIGGER_ANALYTICS_RESET = 'TRIGGER_ANALYTICS_RESET';
export const TRIGGER_STORE_SEARCH_EVENT = 'TRIGGER_STORE_SEARCH_EVENT';
export const BOPIS_DEFAULT_STORE_CHANGE = 'BOPIS_DEFAULT_STORE_CHANGE';
